import { render, staticRenderFns } from "./remainderModal.vue?vue&type=template&id=3308c074&scoped=true"
import script from "./remainderModal.vue?vue&type=script&lang=js"
export * from "./remainderModal.vue?vue&type=script&lang=js"
import style0 from "./remainderModal.vue?vue&type=style&index=0&id=3308c074&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3308c074",
  null
  
)

export default component.exports